import Service from '@/helpers/service'

export default {

    get(params) {
        return Service().get('department', {params});
    }, 
    show(id) {
        return Service().get('department/show/'+id);
    },    
    create(params) {
        return Service().post('department/create', params);
    },
    update(id, params) {
        return Service().post('department/update/'+id, params);
    },
    delete(id) {
        return Service().post('department/delete/'+id);
    }
}